import React from 'react'
import { cn } from '@/lib/utils'
import { useTabSwitch } from '../../hooks'
import { Nav, NavLink, NavItem, TabContent, TabPane } from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'
import { Folder, Send, History, Settings } from 'lucide-react'

import DocumentBrowser from './components/DocumentBrowser'
import TransmittalsList from './components/TransmittalsList'
import ActivityLog from './components/ActivityLog'
import DocControlSettings from './components/DocControlSettings'

const DocControl: React.FC = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useTabSwitch('documents')

  return (
    <div className="doc-control-module">
      {/* Page Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold mb-0">{t('DocControl_title')}</h1>
      </div>

      {/* Navigation Tabs */}
      <div className="tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'documents' })}
              onClick={() => setActiveTab('documents')}
            >
              <Folder className="h-4 w-4 mr-2" />
              {t('DocControl_tab_documents')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'transmittals' })}
              onClick={() => setActiveTab('transmittals')}
            >
              <Send className="h-4 w-4 mr-2" />
              {t('DocControl_tab_transmittals')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'activity' })}
              onClick={() => setActiveTab('activity')}
            >
              <History className="h-4 w-4 mr-2" />
              {t('DocControl_tab_activity')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'settings' })}
              onClick={() => setActiveTab('settings')}
            >
              <Settings className="h-4 w-4 mr-2" />
              {t('DocControl_tab_settings')}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="documents">
            <DocumentBrowser />
          </TabPane>
          <TabPane tabId="transmittals">
            <TransmittalsList />
          </TabPane>
          <TabPane tabId="activity">
            <ActivityLog />
          </TabPane>
          <TabPane tabId="settings">
            <DocControlSettings />
          </TabPane>
        </TabContent>
      </div>
    </div>
  )
}

export default DocControl
